/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown> }} Case_History_Headline_Case_MovedInputs */

const en_case_history_headline_case_moved = /** @type {(inputs: Case_History_Headline_Case_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Case moved to ${i?.step}`)
};

const pt_br2_case_history_headline_case_moved = /** @type {(inputs: Case_History_Headline_Case_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caso movido para ${i?.step}`)
};

/**
* | output |
* | --- |
* | "Case moved to {step}" |
*
* @param {Case_History_Headline_Case_MovedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_case_moved = /** @type {((inputs: Case_History_Headline_Case_MovedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Case_MovedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_case_moved(inputs)
	return pt_br2_case_history_headline_case_moved(inputs)
});